import { render, staticRenderFns } from "./addTravelCateAd.vue?vue&type=template&id=48e11e5b&scoped=true&"
import script from "./addTravelCateAd.vue?vue&type=script&lang=js&"
export * from "./addTravelCateAd.vue?vue&type=script&lang=js&"
import style0 from "./addTravelCateAd.vue?vue&type=style&index=0&id=48e11e5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e11e5b",
  null
  
)

export default component.exports